import type { apiErrorResponse, parsedApiError } from "@/types/api/errors.api";
import axios from "axios";

function isApiErrorResponse(obj: any): obj is apiErrorResponse {
  return (
    obj &&
    typeof obj.message === "string" &&
    typeof obj.code === "string" &&
    (typeof obj.details === "object" || obj.details === null)
  );
}

export const parseApiError = (error: unknown): parsedApiError => {
  const defaultError: parsedApiError = {
    generalMessage:
      "Ocurrió un error inesperado. Por favor, inténtelo de nuevo.",
    fieldErrors: {},
    code: "unknown_frontend_error",
  };

  let errorData: unknown;

  if (axios.isAxiosError(error) && error.response) {
    const responseData = error.response.data;
    errorData = responseData?.error ?? responseData;
  } else if (error instanceof Error) {
    defaultError.generalMessage = error.message;
    return defaultError;
  } else {
    errorData = error;
  }

  if (isApiErrorResponse(errorData)) {
    const fieldErrors: Record<string, string> = {};

    if (errorData.code === "validation_error" && errorData.details) {
      for (const [field, messages] of Object.entries(errorData.details)) {
        if (Array.isArray(messages) && messages.length > 0) {
          fieldErrors[field] = messages[0];
        } else if (typeof messages === "string") {
          fieldErrors[field] = messages;
        }
      }
    }

    const nonFieldErrors = (errorData.details as any)?.non_field_errors;
    const generalMessage =
      Array.isArray(nonFieldErrors) && nonFieldErrors.length > 0
        ? nonFieldErrors[0]
        : errorData.message;

    return {
      generalMessage,
      fieldErrors,
      code: errorData.code,
    };
  }

  return defaultError;
};
